import { Event, eventSchema } from "@fatbees/schemas";

export async function putEvent(event: Event): Promise<Event> {
  const response = await fetch(`/api/events/${encodeURIComponent(event.id)}`, {
    method: "PUT",
    body: JSON.stringify(event),
    headers: { "content-type": "application/json" },
    credentials: "same-origin",
  });
  if (response.ok) {
    return eventSchema.parse(await response.json());
  } else {
    throw new Error(response.statusText);
  }
}

export async function deleteEvent(event: Event): Promise<void> {
  const response = await fetch(`/api/events/${encodeURIComponent(event.id)}`, {
    method: "DELETE",
    credentials: "same-origin",
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
}
